

export const CARDPOOL = {
  CUBE: '_cube_:',
  CUSTOM: '_custom_:'
};
